export default "__VITE_ASSET__68lh8N4B__"